export function sortData(data) {
  let types = ['dialog', 'pattern', 'voca', 'quiz'];
  let sortedData = [];

  types.map(type => {
    let tmpArray = data.filter(val => val.type === type);

    if (tmpArray.length > 0) {
      let is_test = tmpArray[0].is_test;

      if (type === 'quiz') {
        tmpArray = sortQuiz(...tmpArray);
      } else if (type === 'pattern') {
        tmpArray = sortPattern(...tmpArray);
      }
      let jsonObj = { type: type, is_test: is_test, sets: tmpArray };
      sortedData.push(jsonObj);
    }
    return sortedData;
  });
  return sortedData;
}

function sortPattern(arry) {
  let returnArray = [];

  if (!arry.is_test) {
    let patterns = [];
    let examples = [];

    arry.set.forEach(pattern => {
      patterns.push(pattern.pattern_exp);
      examples.push(pattern.examples);
    });
    returnArray.push(
      Object.assign({}, arry, {
        patterns: patterns,
        examples: examples,
        set: null,
        exp: null,
        selected: null
      })
    );
  } else {
    let sets = [];
    arry.set.forEach(pattern => {
      sets = sets.concat(pattern.examples);
    });
    returnArray.push(Object.assign({}, arry, { set: sets }));
  }

  return returnArray;
}

export function sortSession(data) {
  let types = ['patterns', 'vocas'];
  let sortedSession = [];
  let jsonObj = {};

  types.map(type => {
    let tmpArray = data[0][type];

    if (tmpArray.length > 0) {
      let tmpType = '';
      if (type === 'patterns') {
        tmpType = 'pattern';
        let patterns = [];
        let examples = [];

        tmpArray.forEach(pattern => {
          let obj = { ...pattern };
          delete obj['examples'];
          patterns.push(obj);
          examples.push(pattern.examples);
        });

        jsonObj = {
          type: tmpType,
          is_test: false,
          sets: [
            {
              patterns: patterns,
              examples: examples,
              set: null,
              exp: null,
              selected: null
            }
          ]
        };
      } else if (type === 'vocas') {
        tmpType = 'voca';
        jsonObj = { type: tmpType, is_test: false, sets: [{ set: tmpArray }] };
      }
      // let jsonObj = {type: tmpType, is_test:false, sets: [{set:tmpArray}]};
      sortedSession.push(jsonObj);
    }
    return sortedSession;
  });

  return sortedSession;
}

function sortQuiz(arry) {
  return arry.set.forEach(quiz => {
    return {
      answer: quiz.answer,
      user_answer: quiz.user,
      type: quiz.type,
      header: { material: quiz.material, question: quiz.question },
      body: [quiz['A'], quiz['B'], quiz['C'], quiz['D']]
    };
  });
}

export function sortQuiz2(arry) {
  return arry.logs.map(quiz => {
    return {
      answer: quiz.answer,
      user_answer: quiz.user,
      type: quiz.type,
      header: { material: quiz.material, question: quiz.question },
      body: [quiz['A'], quiz['B'], quiz['C'], quiz['D']]
    };
  });
}

export function createSoundState(data) {
  let quiz_length = data.length;
  let sound_array = [];

  for (let i = 0; i < quiz_length; i++) {
    let jsonObj = {
      material: 'STOPPED',
      question: 'STOPPED',
      choices: Array(data[i].body.length).fill('STOPPED')
    };
    sound_array.push(jsonObj);
  }

  return sound_array;
}

export function jsUcfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function keyCheck(key, type, max) {
  if (type === 'Next' && key % max === 1) {
    return true;
  } else if (type === 'Previous' && key % max === 0) {
    return true;
  } else {
    return false;
  }
}

function getExtension(filename) {
  let parts = filename.split('.');
  return parts[parts.length - 1];
}

export function isImage(filename) {
  let ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case 'gif':
    case 'jpeg':
    case 'jpg':
    case 'png':
    case 'svg':
      return true;

    default:
      return false;
  }
}

export function createThreadForm(data) {
  let formData = new FormData();

  formData.append('key', data.key);
  formData.append('AWSAccessKeyId', data.AWSAccessKeyId);
  formData.append('x-amz-security-token', data['x-amz-security-token']);
  formData.append('policy', data.policy);
  formData.append('signature', data.signature);

  return formData;
}

export function commentArray(comments, userId) {
  let array = comments.reduce(function(filtered, comment) {
    if (comment.author_id === userId) {
      if (Object.keys(filtered).length === 0) {
        filtered = { status: {}, comment: {} };
        filtered.status[comment.id] = true;
        filtered.comment[comment.id] = '';
      } else {
        filtered.status[comment.id] = true;
        filtered.comment[comment.id] = '';
      }
    }
    return filtered;
  }, {});
  return array;
}

export function getLength(state, data, page_size) {
  return (
    state.tokenList.findIndex(x => x === state.token) * page_size +
    data.threads.length
  );
}

export function checkType(pathName, is_first) {
  let Obj = { nav_type: 'AI', description_type: '' };
  if (pathName === '/premium/personal-training') {
    Obj.description_type = 'Training';
  } else if (pathName === '/premium/wrong-notes') {
    Obj.description_type = 'WrongNotes';
  } else if (pathName === '/premium/analysis') {
    Obj.description_type = 'Analysis';
  } else if (pathName === '/premium/coach') {
    Obj.nav_type = 'Coach';
    Obj.description_type = is_first ? 'Coach_1' : 'Coach_2';
  }
  return Obj;
}

export function urlCheck(pathName, string) {
  if (pathName.includes(string)) {
    return 'on';
  } else {
    return;
  }
}

export function specialCheck(pathName) {
  if (
    pathName.includes('/personal-training') ||
    pathName.includes('/wrong-notes') ||
    pathName.includes('/analysis')
  ) {
    return 'on';
  } else {
    return;
  }
}



// WEBPACK FOOTER //
// ./src/util/utils.js